import React, { useMemo } from "react";

export const CONFETTI_COLORS = ["#0ea5e9", "#f59e0b", "#10b981", "#8b5cf6", "#ec4899", "#ef4444", "#facc15"];

export function Confetti() {
  const pieces = useMemo(() => Array.from({ length: 90 }).map((_, i) => ({
    id: i, left: Math.random() * 100, delay: Math.random() * 0.5, duration: 2 + Math.random() * 1.4,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length], size: 7 + Math.random() * 7, round: Math.random() > 0.6,
  })), []);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <span key={p.id} className="confetti-piece" style={{
          left: `${p.left}%`, width: `${p.size}px`, height: `${p.size * 1.4}px`, backgroundColor: p.color,
          borderRadius: p.round ? "50%" : "2px", animationDelay: `${p.delay}s`, animationDuration: `${p.duration}s`,
        }} />
      ))}
    </div>
  );
}

// Radial burst of particles from (x%, y%) — used for Stars (gold, around the card) and Fireworks (colourful, sky-wide).
export function Burst({ x, y, count = 18, radius = 140, colors, delay = 0, size = 6, star = false }) {
  const parts = useMemo(() => Array.from({ length: count }).map((_, i) => {
    const a = (i / count) * Math.PI * 2 + Math.random() * 0.3;
    const r = radius * (0.65 + Math.random() * 0.45);
    return { i, dx: Math.cos(a) * r, dy: Math.sin(a) * r, c: colors[i % colors.length], d: delay + Math.random() * 0.12, s: size * (0.7 + Math.random() * 0.6) };
  }), [count, radius, colors, delay, size]);
  return (
    <div className="pointer-events-none absolute" style={{ left: `${x}%`, top: `${y}%` }} aria-hidden="true">
      <span className="firework-flash" style={{ background: colors[0], "--delay": `${delay}s` }} />
      {parts.map((p) => (
        <span key={p.i} className="burst-particle" style={{
          width: p.s, height: p.s, background: p.c, boxShadow: `0 0 8px ${p.c}`,
          clipPath: star ? "polygon(50% 0,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%)" : undefined,
          borderRadius: star ? 0 : undefined, "--dx": `${p.dx}px`, "--dy": `${p.dy}px`, "--delay": `${p.d}s`, "--dur": star ? "1.3s" : "1.15s",
        }} />
      ))}
    </div>
  );
}

const FIREWORK_SETS = [["#f43f5e", "#fb7185", "#fde68a"], ["#38bdf8", "#a5f3fc", "#ffffff"], ["#a78bfa", "#f0abfc", "#fde68a"], ["#34d399", "#bef264", "#ffffff"], ["#fbbf24", "#fb923c", "#fef3c7"]];

export function Fireworks() {
  const shots = useMemo(() => Array.from({ length: 7 }).map((_, i) => ({
    i, x: 12 + Math.random() * 76, y: 10 + Math.random() * 45, delay: i * 0.38 + Math.random() * 0.2, colors: FIREWORK_SETS[i % FIREWORK_SETS.length],
  })), []);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {shots.map((s) => <Burst key={s.i} x={s.x} y={s.y} delay={s.delay} colors={s.colors} count={22} radius={120 + Math.random() * 60} size={5} />)}
    </div>
  );
}
